import ArrowIcon from './ArrowIcon';
import classNames from '@/external/classNames';
import RtpState from '@/server/components/GameCard/GameInfo/InfoTooltip/GameDetailsTooltip/GameDetailsTable/LiveRtp/helpers/RtpState';

type Props = { state: RtpState; color?: string };

const RtpArrowIcon: FC<Props> = ({ state, color = 'text-chichi' }) => (
  <ArrowIcon
    className={classNames(
      'text-chichi',
      state === 'cold' && 'rotate-180 text-whis',
      color,
    )}
  />
);
export default RtpArrowIcon;
